export const RACES_REG_LINKS_REQUESTS = 'RACES_REG_LINKS_REQUESTS';
export const DISTANCES_REG_LINKS_REQUESTS = 'DISTANCES_REG_LINKS_REQUESTS';
export const WAVES_REG_LINKS_REQUESTS = 'WAVES_REG_LINKS_REQUESTS';

export const CREATE_MAGIC_LINK_REQUEST = 'CREATE_MAGIC_LINK_REQUEST';
